import { BackButton } from '../hooks/useGoBack';

export default function Title({ text }) {
	return <div className="d-flex flex-row align-items-center justify-content-between">
		<h1 className="my-4">{text}</h1>
		<BackButton />
	</div>;
}
